import {buildColumn, XLARGE_CELL_WIDTH} from '@eitje/web_components'
import {ArrayCell} from '~/components/advanced_table/components/cells/array_cell'
import {FirmStatusCell} from '~/components/advanced_table/components/cells/firm_status_cell'
import {getFirmStatus} from '~/helpers'
import {formatDate} from '@eitje/web_components'

export const columns = [
	{
		accessorKey: 'company_name',
		header: 'billing_info',
		width: XLARGE_CELL_WIDTH,
	},
	{
		accessorKey: 'mollie_mandate',
		cell: 'BooleanCell',
		infoIconMessageProps: {
			title: 'records.default.fields.mollie_mandate',
			body: 'tooltips.mollie_mandate',
		},
	},
	{
		id: 'status',
		accessorFn: billingInfo => getFirmStatus(billingInfo.environments),
		cell: FirmStatusCell,
		infoIconMessageProps: {
			title: 'records.default.fields.status',
			body: 'tooltips.status',
		},
	},
	{
		id: 'organisation',
		accessorFn: billingInfo => billingInfo.organisation?.name,
	},
	{
		id: 'environments',
		accessorFn: billingInfo => billingInfo.environments?._map('naam'),
		cell: ArrayCell,
		aggregates: false,
	},
	{
		id: 'country',
		accessorFn: billingInfo => _.upperCase(billingInfo.country),
	},
	{
		accessorKey: 'account_nr',
	},
	{
		accessorKey: 'account_name',
	},
	{
		accessorKey: 'card_issuer',
	},
	{
		accessorKey: 'ignore_mollie',
		cell: 'BooleanCell',
		infoIconMessageProps: {
			title: 'records.default.fields.ignore_mollie',
			body: 'tooltips.ignore_mollie',
		},
	},
	{
		accessorKey: 'note',
		infoIconMessageProps: {
			title: 'records.default.fields.note',
			body: 'tooltips.note',
		},
	},
	{
		accessorKey: 'discount_pct',
	},
	{
		accessorKey: 'discount_amt_per_user',
	},
	{
		accessorKey: 'fixed_amt_per_env',
	},
	{
		accessorKey: 'fixed_amt_per_user',
	},
	{
		accessorKey: 'ignore_vat',
		cell: 'BooleanCell',
		infoIconMessageProps: {
			title: 'records.default.fields.ignore_vat',
			body: 'tooltips.ignore_vat',
		},
	},
	{
		id: 'first_billing_date',
		accessorFn: billingInfo => billingInfo.organisation?.first_billing_date,
		format: formatDate,
	},
	{
		accessorKey: 'id',
	},
	{
		accessorKey: 'created_at',
		format: formatDate,
	},
].map(buildColumn)
